import { createApp } from 'vue/dist/vue.esm-bundler';
import Publications from './Publications.vue';


const mountEl = document.querySelector('[data-app-publications-list]');

if ( mountEl )
{
    createApp(Publications, { 
        ...mountEl.dataset 
    }).mount(mountEl);
}